export default __webpack_public_path__ + "static/media/rclogo-lightgray.1497622a.png";